import firebase from "firebase";
import "firebase/firestore";

const app = {
  apiKey: "AIzaSyDl3JSni681qDkthCXMKPjhzcRr43j6c-I",
  authDomain: "pizzas-f9fba.firebaseapp.com",
  databaseURL: "https://pizzas-f9fba.firebaseio.com",
  projectId: "pizzas-f9fba",
  storageBucket: "pizzas-f9fba.appspot.com",
  messagingSenderId: "217523993064",
  appId: "1:217523993064:web:0165b13f21b5ebb32d4c5d"
};
// Initialize Firebase

export const firebaseApp = firebase.initializeApp(app);
export const dbApp = firebase.firestore(firebaseApp);
